import { Pipe, PipeTransform } from '@angular/core';
import { capitalize, lowerCase, startCase, upperCase } from 'lodash';
import { PartnerCustomerExtIdType } from '../../store/state/administration/partner/constants/partner-external-ids.constant';

@Pipe({
    name: 'partnerTypePipe',
    standalone: false
})
export class PartnerTypePipe implements PipeTransform {
  private valueWithHyphenList = [PartnerCustomerExtIdType.ShipTo, PartnerCustomerExtIdType.SoldTo];

  transform(value: string): string {
    switch (true) {
      case value === this.valueWithHyphenList.find((v: PartnerCustomerExtIdType) => value === v):
        const splitValue = value.split('_');
        return `${capitalize(splitValue[0])}-${lowerCase(splitValue[1])} ${upperCase(splitValue[2])}`;
      default:
        return startCase(value);
    }
  }
}
